import * as React from 'react';
import { Component } from 'react';
import { IdentityService } from '../../services/IdentityService';
import { store } from '../..';
import * as Actions from '../../actions/ActionsIndex';
import { ShowStatusBar } from './GlobalStatusBar';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { LoaderComponent } from '../../controls/Loader';
import { CheckBoxComponent } from '../../controls/CheckBox';


interface IProps {
    OnStatuteAccept: () => void,
    OnStatuteAbort: () => void
}

interface IState {
    LoaderVisible: boolean,
    AgreementsAccepted: boolean,
    ShowHelpBlock: boolean
}

export class AcceptStatuteModalComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            LoaderVisible: false,
            AgreementsAccepted: false,
            ShowHelpBlock: false
        }

        this.AcceptClick = this.AcceptClick.bind(this);
        this.AbortClick = this.AbortClick.bind(this);
        this.OnAcceptSuccess = this.OnAcceptSuccess.bind(this);
        this.OnAcceptError = this.OnAcceptError.bind(this);
        this.OnGetProfileInfoSuccess = this.OnGetProfileInfoSuccess.bind(this);
        this.OnGetProfileInfoError = this.OnGetProfileInfoError.bind(this);
        this.OnAgreementsCheckboxChange = this.OnAgreementsCheckboxChange.bind(this);
    }

    public render() {
        return (
            <div className="accept-statute-modal-component">
                <div className="modal">
                    <div className="modal-main section">
                        <div>
                            <LoaderComponent Visible={this.state.LoaderVisible} />
                            <h3>Zaakceptuj regulamin serwisu</h3>
                            <div className="terms-and-agreements">
                                <CheckBoxComponent
                                    Checked={this.state.AgreementsAccepted}
                                    Label=" "
                                    OnClick={this.OnAgreementsCheckboxChange} />
                                <h5>Oświadczam, iż zapoznałem/am się i akceptuję postanowienia <a href='/regulamin.pdf' target='_blank'>Regulaminu Portalu Znajdź Fizjoterapeutę.</a></h5>
                                {
                                    (this.state.ShowHelpBlock) ?
                                        (<span className="help-block">Wymagana jest apkceptacja regulaminu</span>) :
                                        null
                                }
                                <p>
                                    Administratorem Twoich danych osobowych jest Krajowa Izba Fizjoterapeutów z siedzibą w Warszawie (02-001), przy Alejach Jerozolimskich 93 (adres korespondencyjny: Al. Jerozolimskie 93, 02-001 Warszawa). Twoje dane przetwarzane są w ramach założenia konta w portalu i możliwości skorzystania z jego funkcjonalności. Możesz wyrazić dobrowolną zgodę na otrzymywanie komunikacji marketingowej od KIF i/lub komunikacji marketingowej zawierającej informacje o usługach, w tym promocjach i zniżkach podmiotów współpracujących z nami. Przypominamy, że wyrażenie którejkolwiek ze zgód jest w pełni dobrowolne oraz, że możesz w każdym czasie odwołać udzielone nam zgody. <a href='/klauzula.pdf' target='_blank'>Kliknij tutaj</a>, aby zapoznać się z pełną treścią obowiązku informacyjnego.
                                </p>
                            </div>
                            <div className="buttons">
                                <button className="std-secondary-btn" onClick={this.AbortClick}>Nie akceptuję</button>
                                <button className="std-primary-btn" onClick={this.AcceptClick}>Akceptuję regulamin</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private OnAgreementsCheckboxChange() {
        this.setState({
            AgreementsAccepted: !this.state.AgreementsAccepted
        });
    }

    private AcceptClick(evt) {
        if (this.state.AgreementsAccepted) {
            this.setState({
                LoaderVisible: true
            });
            let service = new IdentityService();
            if (window.location.href.indexOf('customer') !== -1) {
                service.AcceptStatuteCustomer(this.OnAcceptSuccess, this.OnAcceptError);
            } else {
                service.AcceptStatute(this.OnAcceptSuccess, this.OnAcceptError);
            }
        } else {
            this.setState({
                ShowHelpBlock: true
            });
        }
    }

    private AbortClick(evt) {
        this.props.OnStatuteAbort();
    }

    private OnAcceptSuccess(result) {
        if (result.status === 200) {
            let service = new IdentityService();
            service.GetProfileInfo(this.OnGetProfileInfoSuccess, this.OnGetProfileInfoError);
        } else {
            //this.setState({ invalidLoginAttempt: true });
            this.setState({
                LoaderVisible: false
            });
        }
    }

    private OnAcceptError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        if (error.response.status === 500) {
            ShowStatusBar('Error', error.response.data, DEFAULT_STATUS_TIMEOUT);
        }
    }

    private OnGetProfileInfoSuccess(result: any) {
        this.setState({
            LoaderVisible: false
        });
        store.dispatch(Actions.SetProfileInfo(result.data.Value));
        this.props.OnStatuteAccept();
    }

    private OnGetProfileInfoError(error: any) {
        console.log(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Próba logowania nie udała się, spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/AcceptStatuteModal.tsx